import { property, array, defaultVal, optional } from 'class-converter';


export class AcquereurCC {
    @property('id', null, true) id = null;
    @property('success', null, true) success;
    @property('message', null, true) message;
    @property('acquereur', null, true) acquereur = "";
    @property('typeAcquereur', null, true) typeAcquereur = "";
    @property('numeroAcquereur', null, true) numeroAcquereur = "";
    @property('nom', null, true) nom = "";
    @property('prenom', null, true) prenom = "";
    @property('raisonSocialeFR', null, true) raisonSocialeFR = "";
    @property('id_refMar', null, true) id_refMar = null;
    @property('id_refUsi', null, true) id_refUsi = null;
    @property('id_refExp', null, true) id_refExp = null;

    @property('numeroAutorisation', null, true) numeroAutorisation = null;
    @property('numeroAgrement', null, true) numeroAgrement = null;
}
export class CedantCC {
    @property('id', null, true) id;
    @property('success', null, true) success;
    @property('message', null, true) message;
    @property('cedant', null, true) cedant;
    @property('typeCedant', null, true) typeCedant;
    @property('numeroCedant', null, true) numeroCedant;
    @property('nom', null, true) nom;
    @property('prenom', null, true) prenom;
    @property('raisonSocialeFR', null, true) raisonSocialeFR;
    @property('id_refMar', null, true) id_refMar;
    @property('id_refUsi', null, true) id_refUsi;
    @property('id_refExp', null, true) id_refExp;

    @property('numeroAutorisation', null, true) numeroAutorisation = null;
    @property('numeroAgrement', null, true) numeroAgrement = null;
}
export class RefEspece {
    @property('id', null, true) id;
    @property('code', null, true) code;
    @property('libelle', null, true) libelle;
    @property('codeCommun', null, true) codeCommun;
    @property('codeEspece', null, true) codeEspece;
}
export class SourceEspece {
    @property('id', null, true) id;
    @property('disponible', null, true) disponible;
    @property('quantite', null, true) quantite;
    @property('typeTransformation', null, true) typeTransformation;
    @property('sourceDetail', null, true) sourceDetail;
    @property('nomNavire', null, true) nomNavire;
    @property('numeroLicence', null, true) numeroLicence;
    @property('listSource', null, true) listSource;
    @property('checked', null, true) checked;
    @property('armateurExiste', null, true) armateurExiste;
    @property('isPasseParLaHalle', null, true) isPasseParLaHalle;
    @property('actif', null, true) actif;
    @property('bloquee', null, true) bloquee;
    @property('dateBloDeb', null, true) dateBloDeb;
    @property('typeSource', null, true) typeSource;
    @property('refTypeTransf', null, true) refTypeTransf;
    @property('id_refCessionCap', null, true) id_refCessionCap;
    @property('id_refSourceCC', null, true) id_refSourceCC;
    @property('id_refSourceEspeceCCSrc', null, true) id_refSourceEspeceCCSrc;
    @property('id_refSourceEspDCSrc', null, true) id_refSourceEspDCSrc;
    @property('id_refSourceEspETASrc', null, true) id_refSourceEspETASrc;
    @property('id_refDeclaration', null, true) id_refDeclaration;
    @property('refEspece', RefEspece) refEspece;
    @defaultVal(false) @property('selected', null, true) selected;
}

export class SourceCC {
    @property('id', null, true) id;
    @property('success', null, true) success;
    @property('message', null, true) message;
    @property('typeSource', null, true) typeSource = "";
    @property('codeSource', null, true) codeSource = "";
    @property('categoriePeche', null, true) categoriePeche = null;
    @property('id_refDeclarationPeche', null, true) id_refDeclarationPeche;
    @property('id_refEtatAchat', null, true) id_refEtatAchat;
    @property('id_refCessionCapSrc', null, true) id_refCessionCapSrc;
    @property('id_refCessionCap', null, true) id_refCessionCap;
    @array() @property('childrenSrcEsp', SourceEspece) childrenSrcEsp = [];
    @array() @optional() @property('allChildrenSrcEsp', SourceEspece) allChildrenSrcEsp = [];
    @array() @optional() @property('sourceCCList') sourceCCList = [];
}
export default class CessionCapture {
    @property('id', null, true) id;
    @property('numeroCession', null, true) numeroCession;
    @property('numeroCessionComplet', null, true) numeroCessionComplet;
    @property('dateCession', null, true) dateCession;
    @property('categoriePeche', null, true) categoriePeche = null;
    @defaultVal(new Date()) @property('dateSysteme', null, true) dateSysteme;
    @property('etat', null, true) etat;
    @property('typeCedant', null, true) typeCedant;
    @property('typeAcquereur', null, true) typeAcquereur;
    @property('auditLabelDesc', null, true) auditLabelDesc;
    @property('refCedantArm', null, true) refCedantArm;
    @property('refCedantMar', null, true) refCedantMar;
    @defaultVal(new AcquereurCC()) @property('acquereurCCDTO', AcquereurCC) acquereurCCDTO;
    @defaultVal(new CedantCC()) @property('cedantCCDTO', CedantCC) cedantCCDTO;
    @array() @property('childrenSourceCC', SourceCC) childrenSourceCC;

}
export class SourceEspeceView {
    @property('quantite', null, true) quantite;
    @property('nomNavire', null, true) nomNavire;
    @property('refEspece', RefEspece) refEspece;
    @property('source', null, true) source;
    @property('id_refCessionCap', null, true) id_refCessionCap;
    @property('id_refSourceCC', null, true) id_refSourceCC;
    @property('id_refSourceEspeceCCSrc', null, true) id_refSourceEspeceCCSrc;
    @property('id_refSourceEspDCSrc', null, true) id_refSourceEspDCSrc;
    @property('id_refSourceEspETASrc', null, true) id_refSourceEspETASrc;
    @property('id_refDeclaration', null, true) id_refDeclaration;
    @property('actif', null, true) actif;
    @defaultVal(true) @property('selected', null, true) selected;
}
export class SourceCCView {

    @property('id', null, true) id;
    @property('cc', null, true) cc;
    @property('dc', null, true) dc;
    @property('eta', null, true) eta;
    @property('codeSource', null, true) codeSource;
    @property('typeSource', null, true) typeSource;
    @array() @property('childrenSrcEsp', SourceEspeceView) childrenSrcEsp;
    @array() @optional() @property('allChildrenSrcEsp', SourceEspece) allChildrenSrcEsp = [];

}
export class CessionCaptureView {
    @property('id', null, true) id;
    @property('numeroCessionComplet', null, true) numeroCessionComplet;
    @property('dateCession', null, true) dateCession;
    @property('dateSysteme', null, true) dateSysteme;
    @property('typeAcquereur', null, true) typeAcquereur;
    @property('loginAcquereur', null, true) loginAcquereur;
    @property('raisonSocialAcquereur', null, true) raisonSocialAcquereur;
    @property('prenomAcquereur', null, true) prenomAcquereur;
    @property('nomAcquereur', null, true) nomAcquereur;

    @property('etat', null, true) etat;
    @property('acquereurCCDTO', AcquereurCC) acquereurCCDTO;
    @property('cedantCCDTO', CedantCC) cedantCCDTO;
    @array() @property('childrenSourceCC', SourceCCView) childrenSourceCC;
}